import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PPAuthService } from '../../../core/services/auth.service';
import { MyBookingsService } from '../../../core/services/my-bookings.service';
import { Observable, Subscription, SubscriptionLike as ISubscription } from 'rxjs';
import { map, tap, concatMap, concat, first, distinctUntilChanged, skip, filter  } from 'rxjs/operators';
import { Booking } from '../../../core/models/booking.model';
import { AlertController, ToastController } from '@ionic/angular';
import { environment } from '../../../../environments/environment';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { TranslateService } from "@ngx-translate/core";
import * as moment from 'moment';
import 'moment-timezone';
import 'moment/locale/sl';
moment.tz.setDefault("Europe/Ljubljana");

@Component({
  selector: 'app-booking-detail',
  templateUrl: './booking-detail.page.html',
  styleUrls: ['./booking-detail.page.scss'],
})
export class BookingDetailPage implements OnInit, OnDestroy {

  me2Subscription: Subscription;
  booking$: Observable<Booking>;
  now: Date;

  loading = false;
  toastRef: any;

  constructor( public translateService:TranslateService, public toastController: ToastController, private http: HttpClient, private router: Router, private route: ActivatedRoute, private authService: PPAuthService,  private myBookingsService: MyBookingsService, public alertController: AlertController ) { }

  ngOnInit() {

    this.now = new Date();
    
    this.me2Subscription = this.authService.me2$.subscribe(
      user => {
        if ( user && this.route.snapshot.params.bookingId ) {
          this.booking$ = this.myBookingsService.getBooking$( user.id, this.route.snapshot.params.bookingId ); 
        }
      }
    );

  }

  doWeShowCancelationOption(booking) {
    
    // Determine the midnight before booking.start using moment
    const midnightBeforeStart = moment(booking.start).startOf('day');

    const now = moment();

    return ( !booking.canceled 
      && !booking.paid 
      && ( booking.getRootReal().confirmationNeededPartySize > booking.partySize 
            || now.isBefore( midnightBeforeStart ) ) );
  }

  /*doWeShowCancelationOption( booking ) {

    return ( !booking.canceled 
      && !booking.paid 
      && ( booking.getRootReal().confirmationNeededPartySize > booking.partySize 
            || this.getDiffInMinutes( booking.start ) > 3*24*60 ) );
  }*/

  getDiffInMinutes( start ): number {
    const nowMt = moment();
    const startMt = moment(start);
    return Math.abs(nowMt.diff(startMt, 'minutes'));
  }

  pay( booking ) {

    if ( ( !booking.paymentRequired || booking.paid ) &&  ( !booking.noShowProtection || booking.noShowProtected ) ) {
      return false;
    }

    this.loading = true;

    this.http.post(
      environment.apiUrl + '/stripe/checkout', 
      { bookingId: booking.id }, { observe: 'response' }

    ).subscribe( (response: HttpResponse<any>) => {
      
      const checkoutUrl = response.headers.get('location');

      window.location.href = checkoutUrl;
      this.loading = false;
      
      console.log('navigacija opravljena');
      
    }, error => {

      this.loading = false;

      this.presentToast( 'Nekaj je šlo narobe... Kontaktirajte administratorja.');

      //this.router.navigate( ['/restavracija', this.activatedRoute.snapshot.params.providerId, this.activatedRoute.snapshot.params.shopSlug, 'rezervacija', 'izberi-termin'] );
    
    }); 


  }

  async cancelBooking( booking, lang = 'sl' ) {

    let localTranslations = {

      'sl': {
        'TITLE': 'Odpoved rezervacije', 
        'MSG': 'Ali zares želiš preklicati rezervacijo?', 
        'BTN_NOT_SURE': 'Nisem prepričan', 
        'BTN_YES': 'Da'
      },

      'en': {
        'TITLE': 'Booking cancellation', 
        'MSG': 'Are you sure you want to cancel the reservation?', 
        'BTN_NOT_SURE': 'I am not sure', 
        'BTN_YES': 'Yes'
      },

      'de': {
        'TITLE': 'Stornierung der Reservierung', 
        'MSG': 'Möchten Sie die Reservierung wirklich stornieren?', 
        'BTN_NOT_SURE': 'Ich bin nicht sicher', 
        'BTN_YES': 'Ja'
      },

      'it': {
        'TITLE': 'Cancellazione della prenotazione', 
        'MSG': 'Sei sicuro di voler cancellare la prenotazione?', 
        'BTN_NOT_SURE': 'Non sono sicuro', 
        'BTN_YES': 'Sì'
      }

    }

    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header: localTranslations[lang]['TITLE'],
      message: localTranslations[lang]['MSG'],
      buttons: [
        {
          text: localTranslations[lang]['BTN_NOT_SURE'],
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
            console.log('Confirm Cancel: blah');
          }
        }, {
          text: localTranslations[lang]['BTN_YES'],
          handler: () => {
            
            this.myBookingsService.cancelBooking( booking ).subscribe( result => 
              this.router.navigate( ['/moj-profil', 'moje-rezervacije'] )
            )

          }
        }
      ]
    });

    await alert.present();
  }

  async presentToast( text ) {
    this.toastRef = await this.toastController.create({
      message: text,
      duration: 10000,
      color: 'danger'
    });
    this.toastRef.present();
  }

  ngOnDestroy() {
    this.me2Subscription.unsubscribe();
  }

}
